import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import * as React from 'react';
import { Box, FlexBox } from '../box';
import { EmptyState } from '../empty-state';
import { AccordionTreeHeader } from './header';
import { useExpandedKeys } from './hooks';
const EmptyStateWrapper = styled(Box)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    width: '100%',
    padding: theme.spacing(4)
}));
import { TreeNode } from './node';
export { AccordionTreeHeader } from './header';
export function AccordionTree(props) {
    const { items, slots, actions, groupActions, defaultExpandedKeys, defaultExpandAll, expandedKeys: controlledExpandedKeys, onExpandedChange, componentSlots, slotProps, emptyState } = props;
    const { expandedKeys, handleToggle } = useExpandedKeys({
        items,
        defaultExpandedKeys,
        defaultExpandAll,
        controlledExpandedKeys,
        onExpandedChange
    });
    return (_jsxs(FlexBox, { stack: true, width: "100%", gap: 2, children: [!props.hideHeader && (_jsx(AccordionTreeHeader, { slots: slots, actions: actions, groupActions: groupActions })), items.length === 0 && emptyState ? (_jsx(EmptyStateWrapper, { children: _jsx(EmptyState, { ...emptyState }) })) : (items.map((item) => (_jsx(TreeNode, { item: item, level: 0, slots: slots, actions: actions, groupActions: groupActions, expandedKeys: expandedKeys, onToggle: handleToggle, componentSlots: componentSlots, slotProps: slotProps }, item.key))))] }));
}
